<template>
  <div id="app-home">
    <div class="top1">
      <!-- <img class="imgBac" src="../../assets/home/topBackground.png" alt=""> -->
      <div class="title">员工自助</div>
      <dl class="topCon">
        <dt class="topDt">
          <img :src="userInfo.avatar" alt="" />
        </dt>
        <dd>
          <p>
            {{ userInfo.name }}
          </p>
          <div class="num">您入职{{ userInfo.joindays }}天啦！</div>
          <div>
            <img
              src="@/assets/home/card.png"
              alt=""
              @click="$router.push(`/mobile/card?workcode=${empNo}`)"
              class="slateImg"
            />
          </div>
        </dd>
      </dl>
    </div>
    <div class="content1">
      <div class="contentCon">
        <div class="first-row">
          <div class="left" @click="toMyInfo">
            <div>我的信息</div>
          </div>
          <div class="right">
            <div class="top" @click="toSalary">
              <div>我的工资单</div>
            </div>
            <div class="bottom" @click="toClock">
              <div>我的考勤</div>
            </div>
          </div>
        </div>
        <div class="second-row">
          <div class="left">
            <div class="leave" @click="toMyLeave('请假')">请假</div>
            <div class="cancel-leave" @click="toMyLeave('销假')">销假</div>
          </div>
          <div class="right">
            <div class="supplment" @click="toMyLeave('补卡')">补卡</div>
            <div class="overtime" @click="toMyLeave('加班')">加班</div>
          </div>
        </div>
      </div>
    </div>
    <div class="contentBottomCon">
      <div
        class="bottomItem"
        v-for="(item, index) in list"
        :key="index"
        @click="toPath(item)"
      >
        <div class="itemCon" v-if="item.show">
          <div class="left">
            <img :src="item.img" alt="" />
            <div class="leftTit">{{ item.value }}</div>
          </div>
          <div class="right">
            <img src="../../assets/home/right.png" alt="" />
          </div>
        </div>
      </div>
    </div>
    <div class="footer">
      <div v-if="select">
        <div v-if="showAuthPay" @click="setPushOne">
          <img src="@/assets/faxin.svg" alt="" />发薪推送
        </div>
        <div v-if="showAuthBonus" @click="setPushTwo">
          <img src="@/assets/tiaoxin.svg" alt="" />调薪推送
        </div>
        <div v-if="showAuthSalary" @click="setPushThree">
          <img src="@/assets/jiangjin.svg" alt="" />奖金推送
        </div>
        <div v-if="showAuthAttendance" @click="setPushFour">
          <img src="@/assets/kaoqin.svg" alt="" />考勤推送
        </div>
        <div v-if="showAuthAchievements" @click="setPushFive">
          <img class="img" src="@/assets/jixiao.svg" alt="" />绩效推送
        </div>
        <div v-if="showAuthVacation" @click="setPushFix">
          <img class="img" src="@/assets/vacation.svg" alt="" />假期推送
        </div>
        <div v-if="showAuthAbnormal" @click="setPushSeven">
          <img class="img" src="@/assets/Abnormal.svg" alt="" />异常推送
        </div>
        <div v-if="checkIfIcPerm" @click="toPath({'key': 99, 'path': '/management/idcard/index'})">
          <img class="img" src="@/assets/home/ic_management.svg" alt="" />身份证过期管理
        </div>
      </div>
      <img
        src="@/assets/homeTuisong.svg"
        alt=""
        v-if="showSend && showAuthImg"
        @click="setSelect"
      />
    </div>
    <el-dialog :visible.sync="visibleBonus" width="80vw">
      <el-table :data="tableBonus" stripe border class="tableBonus">
        <el-table-column label="姓名" prop="name" />
        <el-table-column label="工号" prop="empNo" />
        <el-table-column label="职务" prop="position" width="150px" />
        <el-table-column label="职级" prop="rank" />
        <el-table-column label="月工资标准(前)" prop="basepay1Old" />
        <el-table-column label="月工资标准(后)">
          <template slot-scope="{ row }">
            <span style="color: #fff">
              {{ row.basepay1 }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="年终奖基数(前)" prop="basepay5Old" />
        <el-table-column label="年终奖基数(后)">
          <template slot-scope="{ row }">
            <span style="color: #fff">
              {{ row.basepay5 }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="岗位津贴标准(前)" prop="basepay19Old" />
        <el-table-column label="岗位津贴标准(后)">
          <template slot-scope="{ row }">
            <span style="color: #fff">
              {{ row.basepay19 }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="生效日期" prop="changeDate" />
      </el-table>
      <div class="pager">
        <el-pagination
          :current-page="pageBonus.pageNum"
          :page-sizes="[10, 20, 40, 60, 100]"
          :page-size="pageBonus.pageSize"
          :total="totalBonus"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="sizeChangeBonus"
          @current-change="currChangeBonus"
        />
      </div>
      <div class="footBtn">
        <el-button type="info" round @click="visibleBonus = false"
          >取消</el-button
        >
        <el-button type="success" round @click="bonusOk">确认</el-button>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="visibleSalary" width="70vw">
      <el-table :data="tableSalary" stripe border class="tableSalary">
        <el-table-column label="激励类型">
          <template slot-scope="{ row }">
            <span v-if="row.bonusType === '1'"> 知识产权激励奖金 </span>
            <span v-else-if="row.bonusType === '2'"> 荣誉体系奖金 </span>
            <span v-else> 其他奖金 </span>
          </template>
        </el-table-column>
        <el-table-column label="姓名" prop="name" />
        <el-table-column label="工号" prop="empNo" />
        <el-table-column label="项目奖金金额" prop="bonusNum" />
        <el-table-column label="发放日期" prop="regtime" />
      </el-table>
      <div class="pager">
        <el-pagination
          :current-page="pageSalary.pageNum"
          :page-sizes="[10, 20, 40, 60, 100]"
          :page-size="pageSalary.pageSize"
          :total="totalSalary"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="sizeChangeSalary"
          @current-change="currChangeSalary"
        />
      </div>
      <div class="footBtn">
        <el-button type="info" round @click="visibleSalary = false"
          >取消</el-button
        >
        <el-button type="success" round @click="salaryOk">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import achievements from "@/assets/home/jixiao.png";
import contract from "@/assets/home/hetong.png";
// import physical from "@/assets/physical.svg";
import parental from "@/assets/home/yuerjia.png";
import socialSecurity from "@/assets/home/shebao.png";
import insurance from "@/assets/home/baoxian.png";
import vacation from "@/assets/home/jiaqi.png";
import release from "@/assets/home/fangxing.png";
import performance from "@/assets/home/performance.png";
import import1 from "@/assets/home/import.png";
import search from "@/assets/home/search.png";
import incomePng from "@/assets/home/incomePng.png";

import api from "@/apis";
import DeviceDetector from "device-detector-js";
import { setDevice } from "@/utils/cookie";
import moment from "moment";
import { getToken } from "@/utils/cookie";
import utils from "@/utils/utils";
export default {
  name: "home",
  data() {
    return {
      permissionList: [],
      info: {},
      empNo: "",
      userInfo: {},
      showSend: true,
      select: false,
      visibleBonus: false,
      visibleSalary: false,
      tableBonus: [],
      tableSalary: [],
      pageBonus: {
        pageNum: 1,
        pageSize: 10,
      },
      pageSalary: {
        pageNum: 1,
        pageSize: 10,
      },
      list: [
       //暂时下架我的绩效功能，把show改为false
        {
          img: achievements,
          value: "我的绩效",
          key: "4",
          path: "/mobile/diligence",
          show: false,
        },
        {
          img: performance,
          value: "业绩奖金",
          key: "12",
          path: "/mobile/performance",
          show: false,
        },
        {
          img: contract,
          value: "我的合同",
          key: "5",
          path: "/mobile/contract",
          show: true,
        },
        // {
        //   img: physical,
        //   value: "员工体检",
        //   key: "6",
        //   path: "https://wx.helianwap.com/mobile/enterprise-space.html",
        //   show: false,
        // },
        {
          img: socialSecurity,
          value: "社保公积金",
          key: "8",
          path: "/mobile/social-security",
          show: true,
        },
        {
          img: parental,
          value: "育儿假查询",
          key: "7",
          path: utils.parseUA().mobile ? "/mobParental" : "/parental",
          // path: "/parental",
          show: false,
        },
        {
          img: insurance,
          value: "商业保险",
          key: "9",
          path: "/insuranceHome",
          show: true,
        },
        {
          img: vacation,
          value: "我的假期&调休",
          key: "10",
          path: "/mobVacation",
          show: true,
        },
        {
          img: release,
          value: "放行条申请",
          key: "11",
          path: `/releasePass?show=true`,
          show: false,
        },
        {
          img: import1,
          value: "工资条导入",
          key: "13",
          path: "/mobile/importWages",
          show: false,
        },
        {
          img: search,
          value: "驻场外勤查询",
          key: "14",
          path: "/mobile/fieldPersonnelSearch/pc",
          show: false,
        },
         {
          img: incomePng,
          value: "在职/收入证明开具",
          key: "15",
          path: "http://oa.nvc-lighting.com:8082/spa/workflow/static4mobileform/index.html?_random=1783925655854#/req?iscreate=1&workflowid=1844",
          show: true,
        },
        {
          img: incomePng,
          value: "身份证信息更新",
          key: "16",
          path: "/mobile/idcard/index",
          show: false,
        },
     
      ],
      value: "",
      totalBonus: 0,
      totalSalary: 0,
      showAuthImg: false,
      showAuthAttendance: false,
      showAuthPay: false,
      showAuthBonus: false,
      showAuthSalary: false,
      showAuthAchievements: false,
      showAuthVacation: false,
      showAuthAbnormal: false,
      showInsurance: false,
      dataType: [],
    };
  },
  computed: {
    checkIfIcPerm() {
      const perms = this.permissionList;
      if (perms) {
        const icManList = perms.filter(x => x.permission === '12');
        console.log('ic managelist ', icManList)
        return icManList && icManList.length > 0
      }
      return false;
    },
  },
  created() {},
  mounted() {
    let token = getToken();
    if (token) {
      this.empNo = token;
      // this.queryRole(token)
      this.getUserinfo();
      this.sendAuth();
      this.redirectRoute();
      if (
        token == "10001402" ||
        token == "10005038" ||
        token == "10004830" ||
        token == "10006279" ||
        token == "10005045" ||
        token == "10003106" ||
        token == "10007431" ||
        token == "10007372"||
        token == "10008704"
      ) {
        // this.list[7].show = true;
        this.list[4].show = true; //育儿假
      }
      if (token == "10005038") {
        this.list[7].show = true;
      }
      if (
        (token == "10008797" ||
          token == "10005038" ||
          token == "10003086" ||
          token == "10007431" ||
          token == "10008646") &&
        this.showSend
      ) {
        this.list[8].show = true;
      }
      if (
        (token == "10007372" ||
          token == "10005038" ||
          token == "10008797" ||
          token == "10006279" ||
          token == "10004457" ||
          token == "10003086" ||
          token == "10007431") &&
        this.showSend
      ) {
        this.list[9].show = true;
      }
      const userInfo = JSON.parse(localStorage.getItem("store")).userInfo;
      if (userInfo.performance == 1) {
        this.list[1].show = true;
      }
      console.log(userInfo, "userInfo");
    } else {
      // eslint-disable-next-line no-undef
      this.$bus.$on("processToken", (res) => {
        this.getUserToken(res);
        // this.queryRole(res)
        if (
          res == "10001402" ||
          res == "10005038" ||
          res == "10004830" ||
          res == "10006279" ||
          res == "10005045" ||
          res == "10003106" ||
          res == "10007431" ||
          res == "10007372"
        ) {
          // this.list[7].show = true;
          this.list[4].show = true;
        }
        if (res == "10005038") {
          this.list[7].show = true;
        }
        if (
          (res == "10008797" ||
            res == "10005038" ||
            res == "10003086" ||
            res == "10007431" ||
            res == "10008646") &&
          this.showSend
        ) {
          this.list[8].show = true;
        }
        if (
          (res == "10007372" ||
            res == "10005038" ||
            res == "10008797" ||
            res == "10006279" ||
            res == "10004457" ||
            res == "10003086" ||
            res == "10007431") &&
          this.showSend
        ) {
          this.list[9].show = true;
        }
        const userInfo = JSON.parse(localStorage.getItem("store")).userInfo;
        if (userInfo.performance == 1) {
          this.list[1].show = true;
        }
      });
    }
  },
  methods: {
    //获取hrToken&用户信息
    getUserToken(empNo) {
      if (empNo) {
        let thisname = empNo;
        if (
          thisname === "17625010228" ||
          thisname === "15093054787" ||
          thisname === "17637403245"
        ) {
          thisname = "10005038";
        }

        api.getUserToken({ username: thisname }).then((data) => {
          console.log(data);
          const info = data.data;
          localStorage.setItem("salaryPhone", info.mobileNo);
          localStorage.setItem("salaryInfo", JSON.stringify(info));

          window.sessionStorage.hrToken = info.auth_token;
          this.$store.commit("changeUserInfo", info);

          this.empNo = empNo;
          this.getUserinfo();
          this.sendAuth();
          this.redirectRoute();
        });
      }
    },
    //获取权限
    sendAuth() {
      api.getSelectPermission({ empNo: this.empNo }).then((data) => {
        const items = data.data;
        // console.log(items);
        items.forEach((item) => {
          if (item.permission === "1") {
            this.showAuthPay = true;
          } else if (item.permission === "2") {
            this.showAuthSalary = true;
          } else if (item.permission === "3") {
            this.showAuthBonus = true;
          } else if (item.permission === "4") {
            this.showAuthAttendance = true;
          } else if (item.permission === "5") {
            this.showAuthImg = true;
          } else if (item.permission === "6") {
            this.showAuthAchievements = true;
          } else if (item.permission === "7") {
            this.showAuthVacation = true;
          } else if (item.permission === "8") {
            this.showAuthAbnormal = true;
          } else if (item.permission === "9") {
            this.showInsurance = true;
            this.list[4].show = true;
          }
        });

        this.permissionList = items;

      });
    },
    //跳转
    toMyInfo() {
      this.$router.push("/mobile/info");
    },
    //跳转
    toSalary() {
      this.$router.push("/mobile/wages");
    },
    //跳转
    toClock() {
      this.$router.push("/attendence");
    },
    //跳转
    toPath(item) {
      if(item.key == "6"){
         window.open(
          "https://wx.helianwap.com/mobile/enterprise-space.html",
          "_blank"
        );
      }else if(item.key == "15"){
        // 在职/收入证明开具
          window.open(
          "http://oa.nvc-lighting.com:8082/spa/workflow/static4mobileform/index.html?_random=1783925655854#/req?iscreate=1&workflowid=1844",
          "_blank"
        );
      }else{
        this.$router.push(item.path);
      }
    },
    toMyLeave(value) {
      switch (value) {
        case "请假":
          window.open(
            "http://oa.nvc-lighting.com:8082/spa/workflow/static4mobileform/index.html?_random=1783925776109#/req?iscreate=1&workflowid=1867",
            "_blank"
          );
          break;
        case "销假":
          window.open(
            "http://oa.nvc-lighting.com:8082/spa/workflow/static4mobileform/index.html?_random=1753669624436#/req?iscreate=1&workflowid=898",
            "_blank"
          );
          break;
        case "补卡":
          window.open(
            "http://oa.nvc-lighting.com:8082/spa/workflow/static4mobileform/index.html?_random=1783925836768#/req?iscreate=1&workflowid=1562",
            "_blank"
          );
          break;
        case "加班":
          window.open(
            "http://oa.nvc-lighting.com:8082/spa/workflow/static4mobileform/index.html?_random=1783925850897#/req?iscreate=1&workflowid=1719",
            "_blank"
          );
          break;
        default:
          break;
      }
    },
    //获取用户信息
    getUserinfo() {
      api.getUserinfo().then((res) => {
        this.userInfo = res.data;
      });
    },
    //获取设备信息
    redirectRoute() {
      const userAgentInfo = navigator.userAgent;
      const Agents = [
        "Android",
        "iPhone",
        "SymbianOS",
        "Windows Phone",
        "iPad",
        "iPod",
      ];

      const deviceDetector = new DeviceDetector();
      let device = deviceDetector.parse(userAgentInfo);
      setDevice(
        device.device.brand + " " + device.os.name + " " + device.client.name
      );

      for (let v = 0; v < Agents.length; v++) {
        if (userAgentInfo.indexOf(Agents[v]) > 0) {
          this.showSend = false;
          break;
        }
      }
    },
    setSelect() {
      if (this.select === false) {
        this.select = true;
      } else {
        this.select = false;
      }
    },
    //跳转
    setPushOne() {
      this.$router.push({ path: "/mobile/depament", query: { type: "1" } });
    },
    //调薪推送
    setPushTwo() {
      this.visibleBonus = true;
      this.getTableBonus();
    },
    //奖金推送
    setPushThree() {
      this.visibleSalary = true;
      this.getTableSalary();
    },
    //考勤推送
    setPushFour() {
      this.$router.push({ path: "/mobile/depament", query: { type: "4" } });
    },
    //绩效推送
    setPushFive() {
      this.$router.push({ path: "/mobile/depament", query: { type: "5" } });
    },
    //假期推送
    setPushFix() {
      this.$router.push({ path: "/mobile/depament", query: { type: "6" } });
    },
    //异常推送
    setPushSeven() {
      this.$router.push({ path: "/mobile/depament", query: { type: "7" } });
    },
    //获取表格数据
    getTableBonus() {
      let obj = {
        operateTime: moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
        searchDate: moment(new Date()).format("YYYY-MM"),
        searchType: "1",
        operateType: "1",
        operateNo: this.empNo,
        orgIdList: "",
      };
      api.getSelectSalaryList({ ...obj, ...this.pageBonus }).then((data) => {
        let items = data.data.list;
        items.forEach((item) => {
          item.changeDate = moment(item.changeDate).format("YYYY-MM-DD");
        });
        this.tableBonus = items;
        this.totalBonus = data.data.total;
      });
    },
    //获取工资表格数据
    getTableSalary() {
      let obj = {
        operateTime: moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
        searchDate: moment(new Date()).format("YYYY-MM"),
        searchType: "2",
        operateType: "1",
        operateNo: this.empNo,
        orgIdList: "",
      };
      api.getSelectSalaryList({ ...obj, ...this.pageSalary }).then((data) => {
        let items = data.data.list;
        items.forEach((item) => {
          item.regtime = moment(item.regtime).format("YYYY-MM-DD");
        });
        this.tableSalary = items;
        this.totalSalary = data.data.total;
      });
    },
    //确认推送
    bonusOk() {
      let obj = {
        operateTime: moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
        searchDate: moment(new Date()).format("YYYY-MM"),
        searchType: "1",
        operateType: "2",
        pageNum: "1",
        pageSize: "10",
        operateNo: this.empNo,
        orgIdList: "",
      };
      api.getSelectSalaryList({ ...obj, ...this.pageBonus }).then(() => {
        this.$notify({
          type: "success",
          message: "推送成功",
        });
        this.visibleBonus = false;
      });
    },
    //确认薪资推送
    salaryOk() {
      let obj = {
        operateTime: moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
        searchDate: moment(new Date()).format("YYYY-MM"),
        searchType: "2",
        operateType: "2",
        pageNum: "1",
        pageSize: "10",
        operateNo: this.empNo,
        orgIdList: "",
      };
      api.getSelectSalaryList({ ...obj, ...this.pageSalary }).then(() => {
        this.$notify({
          type: "success",
          message: "推送成功",
        });
        this.visibleSalary = false;
      });
    },
    //分页
    sizeChangeSalary(value) {
      this.pageSalary.pageSize = value;
      this.getTableSalary();
    },
    //分页
    currChangeSalary(value) {
      this.pageSalary.pageNum = value;
      this.getTableSalary();
    },
    //分页
    sizeChangeBonus(value) {
      this.pageBonus.pageSize = value;
      this.getTableBonus();
    },
    //分页
    currChangeBonus(value) {
      this.pageBonus.pageNum = value;
      this.getTableBonus();
    },
    //获取放行条权限
    queryRole(username) {
      api.queryRoleApi({ username }).then((res) => {
        if (res.code == 200) {
          this.dataType = res.data.map((item) => item.dataType);
          console.log("dataType2222", this.dataType);
          if (res.data.length == 0) {
            this.list[6].show = false;
          } else {
            // 权限包含 3 4 时 可以看到车辆放行 ，为2时只能从 员工自助进入 ，为1时没有放行条权限
            if (this.dataType.includes(4)) {
              this.list[6].show = true;
            } else if (this.dataType.includes(3)) {
              this.list[6].show = false;
            } else if (this.dataType.includes(2)) {
              this.list[6].show = true;
            }
          }
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
$zoom: 1020 / 375;

// 小屏幕设备 （手机等，宽度 ≤ 600px）
@media screen and (max-width: 600px) {
  #app-home {
    width: 100%;
  }
}

@media screen and (min-width: 600px) {
  #app-home {
    width: 276px * $zoom;
  }
}

#app-home {
  font-size: 16px * $zoom;
  position: relative;
  background-color: #f7f9fa;
  min-height: 100vh;
  padding-bottom: 30px;

  &::v-deep .send-btn {
    width: 130px;
    height: 130px;
    overflow: auto;
    border-radius: 0;

    .img-box {
      box-shadow: none;
      background-size: contain;
      border-radius: 0;
    }
  }
}

// .top {
//   width: 100%;
//   height: 72pt;
//   // height: 572px;
//   display: flex;
//   align-items: center;
//   justify-content: space-between;
//   padding: 0 10px * $zoom;
//   // background-image: url('../../assets/home/topBackground.png');
//   // background-size: 100% 100%;

//   .slateImg {
//     width: 24pt;
//   }

//   dl {
//     display: flex;
//     align-items: center;

//     .topDt {
//       img {
//         width: 46pt;
//         border-radius: 50%;
//         margin-right: 10px * $zoom;
//       }
//     }

//     dd {
//       font-size: 18pt;

//       // line-height: 25px * $zoom;
//       // font-weight: 600;
//       span {
//         font-size: 12pt;
//         font-weight: normal;
//       }
//     }
//   }
// }

// .content {
//   width: 100%;
//   flex: 1;

//   .conImg {
//     width: 100%;
//     height: 30%;

//     img {
//       width: 100%;
//     }
//   }

//   .conBox {
//     width: 90%;
//     // height: 200px * $zoom;
//     background: #fff;
//     border-radius: 20px * $zoom;
//     position: absolute;
//     left: 5%;
//     top: 85%;
//     box-shadow: 0px 10px 15px 5px #f4f4f4;
//     display: flex;
//     flex-wrap: wrap;

//     div:nth-child(3) {
//       .conBox_three {
//         border-right: none;
//       }
//     }

//     div:nth-child(6) {
//       .conBox_three {
//         border-right: none;
//       }
//     }

//     .conBox_one {
//       width: 33.3%;

//     }

//     .conBoxImg {
//       width: 32px * $zoom;
//       height: 32px * $zoom;
//     }

//     .bigImg {
//       transform: scale(1.5);
//     }

//     .conBox_three {
//       display: flex;
//       align-items: center;
//       justify-content: center;
//       flex-direction: column;
//       border-bottom: 1px solid #f4f4f4;
//       border-right: 1px solid #f4f4f4;
//       padding: 20px * $zoom 0;

//       .conBox_five {
//         font-size: 12pt;
//       }
//     }
//   }
// }

// .footer {
//   position: absolute;
//   top: 200%;
//   right: 1%;
//   display: flex;
//   flex-direction: column;
//   align-items: flex-end;

//   img {
//     width: 55px * $zoom;
//     cursor: pointer;
//   }

//   &>div {
//     border: 1px solid #f6f6f6;
//     box-shadow: 0px 0px 20px 2px rgba(0, 0, 0, 0.07);
//     font-size: 26px;

//     div {
//       padding: 20px 40px;
//       color: #6d6c6c;
//       cursor: pointer;
//       display: flex;
//       align-items: center;

//       img {
//         width: 35px;
//         margin-right: 10px;
//       }

//       .img {
//         width: 30px;
//         margin-left: 5px;
//       }
//     }
//   }
// }

.top1 {
  width: 100%;
  height: 218pt;
  // height: 772px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  // padding: 0 10px * $zoom;
  background-image: url("../../assets/home/topBackground.png");
  background-size: 100% 100%;
  position: relative;

  .title {
    font-size: 14pt;
    color: #fff;
    position: absolute;
    top: 12%;
    right: 40%;
  }

  .imgBac {
    width: 100%;
    height: 100%;
  }

  .slateImg {
    width: 20pt;
  }

  .topCon {
    position: absolute;
    top: 28%;
    left: 7%;
    display: flex;

    // align-items: center;
    p {
      font-size: 32px;
    }

    .topDt {
      img {
        width: 41pt;
        border-radius: 50%;
        margin-right: 10px * $zoom;
      }
    }

    dd {
      font-size: 14pt;
      color: #ffffff;

      // line-height: 25px * $zoom;
      // font-weight: 600;
      .num {
        font-size: 10pt;
        font-weight: normal;
        margin: 10px 0 15px 0;
      }
    }
  }
}

.content1 {
  position: absolute;
  top: 135pt;
  left: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  .contentCon {
    width: 92%;
    // height: 158pt;
    padding: 28px 30px;
    background-image: url("../../assets/home/conBackground.png");
    background-size: 100% 100%;
    .first-row {
      height: 130pt;
      display: flex;
      align-content: center;
      justify-content: space-between;
      .left {
        height: 100%;
        width: 48%;
        background-image: url("../../assets/home/info.png");
        background-size: 100% 100%;
        position: relative;

        div {
          font-size: 10pt;
          position: absolute;
          left: 10pt;
          top: 20pt;
          color: #2ea355;
          font-weight: 550;
        }
      }

      .right {
        width: 48%;
        height: 100%;
        display: flex;
        align-content: center;
        justify-content: space-between;
        flex-direction: column;

        .top {
          height: 48%;
          background-image: url("../../assets/home/gongzidan.png");
          background-size: 100% 100%;
          position: relative;

          div {
            font-size: 10pt;
            color: #ff9600;
            font-weight: 550;
            display: flex;
            align-content: center;
            position: absolute;
            left: 10pt;
            top: 40%;
          }
        }

        .bottom {
          height: 48%;
          background-image: url("../../assets/home/kaoqin.png");
          background-size: 100% 100%;
          position: relative;

          div {
            font-size: 10pt;
            color: #7e6de8;
            font-weight: 550;
            display: flex;
            align-content: center;
            position: absolute;
            left: 10pt;
            top: 40%;
          }
        }
      }
    }
    .second-row {
      display: flex;
      justify-content: space-between;
      height: 55pt;
      margin-top: 8pt;
      font-size: 10pt;
      font-weight: 550;

      // 公共卡片样式（避免重复）
      .card-style {
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        align-items: center;
        border-radius: 12px;
        width: 48%;
        background-size: 100% 100%;
        padding-bottom:   5px ; // 统一内边距
      }

      // 左右两侧容器公共样式
      .left,
      .right {
        display: flex;
        width: 48%;
        gap: 20px;
      }

      // 左侧卡片
      .leave {
        @extend .card-style;
        color: rgb(85, 114, 150);
        background-image: url("../../assets/home/leave.png");
      }
      .cancel-leave {
        @extend .card-style;
        color: rgb(140, 37, 63);
        background-image: url("../../assets/home/cancel-leave.png");
      }

      // 右侧卡片
      .supplment {
        @extend .card-style;
        color: rgb(191, 175, 100);
        background-image: url("../../assets/home/supplment.png");
      }
      .overtime {
        @extend .card-style;
        color: rgb(120, 84, 57);
        background-image: url("../../assets/home/overtime.png");
      }
    }
  }
}

.contentBottomCon {
  margin-top: 152pt;
  border-radius: 10px;

  .bottomItem:last-child {
    .itemCon {
      border: 0;
      border-radius: 0 0 10px 10px;
    }
  }

  .bottomItem:first-child {
    .itemCon {
      border-radius: 10px 10px 0 0;
    }
  }

  .bottomItem {
    width: 100%;

    .itemCon {
      display: flex;
      justify-content: space-between;
      align-content: center;
      flex-wrap: wrap-reverse;
      height: 40pt;
      margin: 0 30px;
      padding: 0 30px;
      border-bottom: 1px solid #ebedf2;
      background-color: #fff;
    }

    .left {
      display: flex;
      align-content: center;

      img {
        width: 23pt;
        height: 23pt;
      }

      .leftTit {
        font-size: 11.5pt;
        line-height: 23pt;
        margin-left: 11pt;
      }
    }

    .right {
      img {
        width: 7pt;
        height: 11pt;
      }
    }
  }
}

.footer {
  position: absolute;
  top: 86%;
  right: 1%;
  display: flex;
  // flex-direction: column;
  align-items: flex-start;

  img {
    width: 55px * $zoom;
    cursor: pointer;
  }

  & > div {
    border: 1px solid #f6f6f6;
    box-shadow: 0px 0px 20px 2px rgba(0, 0, 0, 0.07);
    font-size: 26px;
    margin-top: -390px;

    div {
      padding: 20px 40px;
      color: #6d6c6c;
      cursor: pointer;
      display: flex;
      align-items: center;

      img {
        width: 35px;
        margin-right: 10px;
      }

      .img {
        width: 30px;
        margin-left: 5px;
      }
    }
  }
}

.tableBonus {
  ::v-deep .has-gutter {
    .cell {
      color: #fff;
    }
  }

  ::v-deep .cell {
    line-height: 55px;
    text-align: center;
  }

  ::v-deep th.el-table__cell {
    background-color: #499f6d;
  }

  ::v-deep .el-table_1_column_6 {
    background-color: #db9141 !important;
  }

  ::v-deep .el-table_1_column_8 {
    background-color: #db9141 !important;
  }

  ::v-deep .el-table_1_column_10 {
    background-color: #db9141 !important;
  }
}

.tableSalary {
  ::v-deep .has-gutter {
    .cell {
      color: #fff;
    }
  }

  ::v-deep .cell {
    line-height: 55px;
    text-align: center;
  }

  ::v-deep th.el-table__cell {
    background-color: #499f6d;
  }
}

.pager {
  display: flex;
  justify-content: flex-end;
  margin-top: 50px;
}

.footBtn {
  margin-top: 40px;
  display: flex;
  justify-content: center;

  .el-button {
    width: 200px;
    height: 60px;
    margin-right: 40px;
    font-size: 16px;
  }
}

::v-deep .el-dialog__body {
  max-height: 1200px !important;
  overflow-y: scroll;
}
</style>
